<template>
    <div>
        <div class="container-fluid mt-45">
            <Breadcrumbs />
        </div>

        <div class="container mt-4">
            <div class="row justify-content-center">
                <div class="col-lg-5 col-md-8">
                    <div class="card border-0 shadow">
                        <div class="card-body py-5 px-55">
                            <h2>Create or select a patient</h2>
                            
                            <div class="mt-45">
                                <router-link :to="{name: 'CreatePatient'}" class="btn btn-success btn-block btn-lg lg-shadow px-0">Create a new patient</router-link>
                                <button @click="selectExistingPatient()" class="btn btn-primary btn-block btn-lg lg-shadow mt-4 px-0">Select an existing patient</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import Breadcrumbs from '@/partials/site-structure/BreadcrumbsComponent.vue'
export default {
    name: 'CreateOrSelectPatient',

    components: {
        Breadcrumbs
    },

    methods: {
        ...mapActions({
            clearCreatedPatientFromTestStore: 'TestStore/ClearCreatedPatient'
        }),

        selectExistingPatient() {
            return this.$router.push({name: 'SelectAPatient'})
        }
    }
}
</script>